import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  input,
  output,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../presentation/icon/icon.component';
import { CopyDirective } from '../../../directives/copy.directive';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';
import {
  SectionGroupSettings,
  ISectionGroupSettings,
  UTILS,
} from '@aksia/infrastructure';
import { UiLoadingDirective } from '../../../directives/ui/ui-loading.directive';
import { UiContentComponentDirective } from '../../../directives/ui/ui-content-component.directive';

@Component({
  selector: 'section-group',
  imports: [
    CommonModule,
    IconComponent,
    CopyDirective,
    UiLoadingDirective,
    RouterOutlet,
  ],
  exportAs: 'section-group',
  templateUrl: './section-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: UiContentComponentDirective,
      inputs: ['uicontentcomponent', 'uicontentinput'],
    },
    {
      directive: UiLoadingDirective,
      inputs: ['uiloading: sectiongrouploading'],
    },
  ],
})
export class SectionGroupComponent extends UiControlDirective {
  //#region Injections

  protected readonly contentDir = inject(UiContentComponentDirective);
  protected readonly loadingDir = inject(UiLoadingDirective);

  //#endregion

  //#region Inputs/Outputs

  override settings = input<SectionGroupSettings, ISectionGroupSettings>(
    new SectionGroupSettings(),
    {
      transform: (settings: ISectionGroupSettings) =>
        this.initSettings(settings),
    },
  );

  onToggle = output<boolean>();

  //#endregion

  //#region Host Bindings

  @HostBinding('attr.isMulti') isMulti?: boolean;
  @HostBinding('attr.hidePlaceholder') hidePlaceholder?: boolean;
  @HostBinding('attr.isFirst') isFirst?: boolean;
  @HostBinding('attr.isLast') isLast?: boolean;

  //#endregion

  //#region Functions

  constructor() {
    super();
    this.loadingDir.silenced.set(true);
  }

  protected override initSettings(settings: ISectionGroupSettings) {
    let sectionGroupSettings = UTILS.OBJECT.assign(
      new SectionGroupSettings(),
      settings,
    );
    super.initSettings(sectionGroupSettings);
    this.isMulti = sectionGroupSettings.isMulti;
    this.hidePlaceholder = sectionGroupSettings.hidePlaceholder;
    this.isFirst = sectionGroupSettings.isFirst;
    this.isLast = sectionGroupSettings.isLast;
    return sectionGroupSettings;
  }

  protected toggle() {
    this.settings().isMinimized = !this.settings().isMinimized;
    this.onToggle.emit(this.settings().isMinimized ?? false);
  }

  //#endregion
}
